import Loading from '@wikom/react-loading';
import React, { Suspense, lazy } from 'react';
import { Route, Switch } from '@wikom/wikom-router';
import { usePrefix } from './router';
var Rebflaechen = lazy(function () { return import(/* webpackChunkName: "rebflaechen" */ '../rebflaechen'); });
var Pflanzgenehmigungen = lazy(function () { return import(/* webpackChunkName: "pflanzgenehmigungen" */ '../rebflaechen/pflanzgenehmigungen'); });
var Vermarktungsrechte = lazy(function () { return import(/* webpackChunkName: "vermarktungsrechte" */ '../vermarktungsrechte'); });
var Umstrukturierungsantrag = lazy(function () { return import(/* webpackChunkName: "umstrukturierungsantrag" */ '../umstrukturierungsantrag'); });
var Fertigstellungsmeldung = lazy(function () { return import(/* webpackChunkName: "fertigstellungsmeldung" */ '../umstrukturierungsantrag/fertigstellungsmeldung'); });
var Qualitaetsweinpruefung = lazy(function () { return import(/* webpackChunkName: "qualitaetsweinpruefung" */ '../qualitaetsweinpruefung'); });
var Nutzungsarten = lazy(function () { return import(/* webpackChunkName: "nutzungsarten" */ '../nutzungsarten'); });
var Wipzn = lazy(function () { return import(/* webpackChunkName: "wipzn" */ '../wipzn'); });
var Common = lazy(function () { return import(/* webpackChunkName: "common" */ '../common'); });
var AppRoutes = function () {
    var _a = usePrefix().PAGE, REBFLAECHEN = _a.REBFLAECHEN, PFLANZGENEHMIGUNGEN = _a.PFLANZGENEHMIGUNGEN, VERMARKTUNGSRECHTE = _a.VERMARKTUNGSRECHTE, UMSTRUKTURIERUNGSANTRAG = _a.UMSTRUKTURIERUNGSANTRAG, FERTIGSTELLUNGSMELDUNG = _a.FERTIGSTELLUNGSMELDUNG, NUTZUNGSARTEN = _a.NUTZUNGSARTEN, QUALITAETSWEINPRUEFUNG = _a.QUALITAETSWEINPRUEFUNG, WIPZN = _a.WIPZN, COMMON = _a.COMMON;
    return (React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(Switch, null,
            React.createElement(Route, { path: REBFLAECHEN },
                React.createElement(Rebflaechen, null)),
            React.createElement(Route, { path: PFLANZGENEHMIGUNGEN },
                React.createElement(Pflanzgenehmigungen, null)),
            React.createElement(Route, { path: VERMARKTUNGSRECHTE },
                React.createElement(Vermarktungsrechte, null)),
            React.createElement(Route, { path: UMSTRUKTURIERUNGSANTRAG },
                React.createElement(Umstrukturierungsantrag, null)),
            React.createElement(Route, { path: FERTIGSTELLUNGSMELDUNG },
                React.createElement(Fertigstellungsmeldung, null)),
            React.createElement(Route, { path: QUALITAETSWEINPRUEFUNG },
                React.createElement(Qualitaetsweinpruefung, null)),
            React.createElement(Route, { path: NUTZUNGSARTEN },
                React.createElement(Nutzungsarten, null)),
            React.createElement(Route, { path: WIPZN },
                React.createElement(Wipzn, null)),
            React.createElement(Route, { path: COMMON },
                React.createElement(Common, null)))));
};
export default AppRoutes;
